<template>
  <div class="main-layout">
    <AppHeader :current-user="authStore.currentUser" @logout="handleLogout" />
    <main id="main-content" class="main-layout__content">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </main>
    <ToastHost />
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import AppHeader from '@/components/organisms/AppHeader.vue'
import ToastHost from '@/components/organisms/ToastHost.vue'
import { useAuthStore } from '@/stores/auth.store'

const authStore = useAuthStore()
const router = useRouter()

function handleLogout() {
  authStore.logout()
  router.push({ name: 'login' })
}
</script>

<style scoped lang="scss">
.main-layout {
  min-height: 100vh;
  background-color: var(--cds-background, #f4f4f4);
  display: flex;
  flex-direction: column;
}

.main-layout__content {
  flex: 1;
  min-height: 0;
}
</style>
